import { DSSpacer } from '../Spacer/Spacer'
import { DSText } from '../DSText/DSText'
import { styled } from 'styled-components'
import { DSGridSpacing } from '../styles/tokens/grid-spacing-styles'
import { DSFlex } from '../Flex/Flex'

const StyledDivider = styled.hr<{ $size?: number }>`
  border: none;
  border-top: ${(props) => `${props.$size}px solid var(--colour-border);`};
  margin: 0;
  width: 100%;

  &.secondary {
    border-top-color: ${(props) => props.theme.v2.surface.cream100};
  }

  &.brand {
    border-top-width: 3px;
    border-top-color: var(--colour-surface-brand-bold);
  }
`

type DividerProps = {
  content?: string
  height?: number
  variant?: 'primary' | 'secondary' | 'brand'
  verticalSpacing?: DSGridSpacing
}

export const DSDivider = ({ content, verticalSpacing, height, variant }: DividerProps) => {
  if (!content) {
    return (
      <>
        {verticalSpacing && <DSSpacer size={verticalSpacing} direction="vertical" />}
        <StyledDivider $size={height ?? 1} className={variant ?? ''} />
        {verticalSpacing && <DSSpacer size={verticalSpacing} direction="vertical" />}
      </>
    )
  }

  return (
    <DSFlex direction="row" alignItems="center">
      {verticalSpacing && <DSSpacer size={verticalSpacing} direction="vertical" />}
      <StyledDivider $size={height ?? 1} className={variant ?? ''} />
      <DSSpacer size={12} direction="horizontal" />
      <DSText variant="fluid-label-100">{content}</DSText>
      <DSSpacer size={12} direction="horizontal" />
      <StyledDivider $size={height ?? 1} className={variant ?? ''} />
      {verticalSpacing && <DSSpacer size={verticalSpacing} direction="vertical" />}
    </DSFlex>
  )
}
